module.exports = __webpack_public_path__ + "img/data_flow-CN.7d34cbe5.png";